import Paper from '@elementor/ui/Paper';
import { styled } from '@elementor/ui/styles';

export const StyledPaper = styled(Paper)`
	height: 140px;

	display: flex;
	justify-content: center;
	align-items: center;

	& > * {
		max-height: 100%;
		width: auto;
	}
`;

export const StyledThumbnailPaper = styled(Paper)`
	width: 64px;
	height: 40px;

	display: flex;
	justify-content: center;
	align-items: center;

	border-radius: ${({ theme }) => theme.shape.borderRadius}px;
	border: 1px solid ${({ theme }) => theme.palette.divider};

	& > * {
		max-height: 100%;
		max-width: 100%;
		object-fit: contain;
	}
`;
